import React from 'react';
import { FileText, Database, Download, XCircle } from 'lucide-react';
import { decodeExcerpt } from '../../lib/htmlDecode';

export const CitationModal = ({ 
  citationModal, 
  onClose, 
  onDownload 
}) => {
  if (!citationModal) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" style={{ backgroundColor: '#00d4ff' }}>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
              <FileText className="h-5 w-5 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-white text-lg">Source Document</h3>
              <p className="text-white/80 text-sm">{citationModal.filename}</p>
            </div>
          </div>
          <button 
            onClick={onClose}
            className="text-white/80 hover:text-white transition-colors"
          >
            <XCircle className="h-6 w-6" />
          </button>
        </div>
        
        {/* Content */}
        <div className="p-6">
          <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
            <Database className="h-4 w-4 text-cyan-600" />
            Relevant Excerpt
          </h4>
          <div className="bg-gray-50 rounded-lg p-4 text-gray-700 text-sm leading-relaxed max-h-64 overflow-y-auto border border-gray-200">
            {decodeExcerpt(citationModal.excerpt) || 'No excerpt available for this document.'}
          </div>
        </div>
        
        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
          >
            Close
          </button>
          <button
            onClick={() => {
              onDownload({ id: citationModal.docId, filename: citationModal.filename });
              onClose();
            }}
            className="px-4 py-2 bg-cyan-500 hover:bg-cyan-600 text-white rounded-lg flex items-center gap-2 transition-colors"
          >
            <Download className="h-4 w-4" />
            Download Full Document
          </button>
        </div>
      </div>
    </div>
  );
};

export default CitationModal;
